import { baseApi } from "api/BaseApi";

const qaNotificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    triggerNotifyQaResponse: build.mutation<
      void,
      { qa_id: number; response_body: string }
    >({
      query: (body) => ({
        url: "v2/notifications/qa-response/",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useTriggerNotifyQaResponseMutation } = qaNotificationsApi;
